export { categoriesFormsModel } from "./lib/tabs/categoriesFormsModel";
export { mensurationSteps } from "./lib/tabs/mensurationSteps";
export { menagementSteps } from "./lib/tabs/menagementSteps";
export { comunicationsSteps } from "./lib/tabs/comunicationsSteps";

export { mensurationQuestions } from "./lib/questions/mensurationQuestions";
export { menagementQuestions } from "./lib/questions/menagementQuestions";
export { comunicationQuestions } from "./lib/questions/comunicationQuestions";

export { monthsOfYearModel } from "./lib/monthsOfYearModel";
export { sideBarOptions } from "./lib/sideBarOptionsModel";
export { mensurationValues } from "./lib/mensurationValues";
export { companyAtividadesModel } from "./lib/companyAtividadesModel";

export { Auth } from "./lib/entities/Auth";
export { MenagementReport } from "./lib/entities/MenagementReport";
// export { ComunicationReport } from "./lib/entities/ComunicationReport";


// WEBPACK FOOTER //
// src/models/index.js